export enum AccountType {
  ACCOUNT = 'Account',
  ACCOUNT_EX = 'AccountEx',
}
